export const RESPONSE_STATUS = {
  FETCH_ERROR: 'Fetch Error',
  TOKEN_EXPIRED: 'Token Expire',
  PERMISSION_DENIED: 'Permission Denied'
};